import { render, staticRenderFns } from "./Hq.vue?vue&type=template&id=25cf5b3d&scoped=true&"
import script from "./Hq.vue?vue&type=script&lang=ts&"
export * from "./Hq.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cf5b3d",
  null
  
)

export default component.exports